import { api } from '../../AxiosConfig';

class GruposClientesService {
    create(data: any) {
        return api.post('/grupos-clientes/create', data);
    }

    findAll() {
        return api.get('/grupos-clientes/findAll');
    }

    update(id: string, update: any) {
        return api.post('/grupos-clientes/update', { id, update });
    }

    delete(id: string) {
        return api.post('/grupos-clientes/delete', { id });
    }
}

export default new GruposClientesService();
